import { useEffect, useState } from "react";
import { getResourceSearchResults } from "@/api/getResourceSearchResults/getResourceSearchResultsApi";
import { GetResourceSearchResultsItem } from "@/api/getResourceSearchResults/types";

interface UseFeaturedResourcesOptions {
  resourceTypeIds?: number[];
}

export function useFeaturedResources(
  options: UseFeaturedResourcesOptions = {},
) {
  const [featuredResources, setFeaturedResources] = useState<
    GetResourceSearchResultsItem[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFeaturedResources = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const response = await getResourceSearchResults({
          showFeatured: true,
          resourceTypeIds: options.resourceTypeIds,
          page: 1,
          pageSize: 20, // Fetch up to 20 featured resources
        });

        if (response.data && response.data.resources) {
          setFeaturedResources(response.data.resources);
        }
      } catch (err) {
        console.error("Error fetching featured resources:", err);
        setError("Failed to load featured resources");
      } finally {
        setIsLoading(false);
      }
    };

    fetchFeaturedResources();
  }, [JSON.stringify(options.resourceTypeIds)]);

  return {
    featuredResources,
    isLoading,
    error,
  };
}
